/**
 * Échelle géographique canonique de Noam — référence UNIQUE pour tous les modules.
 *
 * Ordre strict du plus petit au plus grand :
 *   local → cantonal → regional → national_federal → continental → intercontinental → mondial
 *
 * Tout module manipulant une échelle géographique (Radar, Positionnement, Origination,
 * Annuaire, Risques, Veille stratégique, Marchés financiers, etc.) DOIT utiliser ces
 * constantes. Aucun ordre différent n'est autorisé.
 */

export const GEO_SCALE_LEVELS = [
  "local",
  "cantonal",
  "regional",
  "national_federal",
  "continental",
  "intercontinental",
  "mondial",
];

export const GEO_SCALE_LABELS = {
  local:            "Local",
  cantonal:         "Cantonal",
  regional:         "Régional",
  national_federal: "National / Fédéral",
  continental:      "Continental",
  intercontinental: "Intercontinental",
  mondial:          "Mondial",
};

export const GEO_SCALE_DEFINITIONS = {
  local:            "Commune, quartier, arrondissement",
  cantonal:         "Le canton (Genève, Vaud, Zurich, etc.)",
  regional:         "Plusieurs cantons ou départements (Suisse romande, Arc lémanique, Île-de-France...)",
  national_federal: "Le pays entier (Suisse, France, etc.)",
  continental:      "Un continent entier (Europe, Afrique, etc.)",
  intercontinental: "Plusieurs continents spécifiques",
  mondial:          "L'ensemble du globe",
};

// Mode additif : alias permettant de tolérer les anciennes valeurs persistées en base
const GEO_SCALE_ALIASES = {
  national:      "national_federal",
  federal:       "national_federal",
  international: "intercontinental",
  global:        "mondial",
  world:         "mondial",
  monde:         "mondial",
};

/**
 * Normalise une entrée vers une valeur canonique GEO_SCALE_LEVELS.
 * Inconnu/vide → `defaultLevel`.
 */
export function normalizeGeoLevel(value, defaultLevel = "national_federal") {
  if (!value) return defaultLevel;
  const v = String(value).trim();
  if (GEO_SCALE_LEVELS.includes(v)) return v;
  return GEO_SCALE_ALIASES[v] || GEO_SCALE_ALIASES[v.toLowerCase()] || defaultLevel;
}

/** Renvoie l'index ordinal (0=local, 6=mondial). -1 si inconnu. */
export function geoIndex(value) {
  const norm = normalizeGeoLevel(value, "");
  const idx = GEO_SCALE_LEVELS.indexOf(norm);
  return idx;
}

/** Libellé humain affichable. */
export function geoLabel(value) {
  return GEO_SCALE_LABELS[normalizeGeoLevel(value)] || value || "—";
}

/** Liste prête pour <select> : [{value, label, description}, ...] */
export const GEO_SCALE_OPTIONS = GEO_SCALE_LEVELS.map((k) => ({
  value: k,
  label: GEO_SCALE_LABELS[k],
  description: GEO_SCALE_DEFINITIONS[k],
}));
